import { render, staticRenderFns } from "./NotificationListModal.vue?vue&type=template&id=f5709e4c&scoped=true"
import script from "./NotificationListModal.vue?vue&type=script&lang=js"
export * from "./NotificationListModal.vue?vue&type=script&lang=js"
import style0 from "./NotificationListModal.vue?vue&type=style&index=0&id=f5709e4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5709e4c",
  null
  
)

export default component.exports